import { Box, styled } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

import Link from 'components/ui/Link';
import Logo from 'components/ui/Logo';
import MainCard from 'components/ui/MainCard';

const useStyles = makeStyles()((theme) => ({
  card: {
    '& > *': {
      flexGrow: 1,
      flexBasis: '50%',
    },

    [theme.breakpoints.down('sm')]: {
      margin: '20px',
    },
    [theme.breakpoints.down('lg')]: {
      maxWidth: '400px',
    },
  },
  content: {
    padding: `${theme.spacing(5)} !important`,

    [theme.breakpoints.down('lg')]: {
      padding: `${theme.spacing(3)} !important`,
    },
  },
}));

const AuthWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor:
    theme.palette.mode === 'dark'
      ? theme.palette.background.default
      : theme.palette.primary.light,
  minHeight: '100vh',
  m: { xs: 1, sm: 3 },
  mb: 0,
}));

const LoggedOutLayout = ({ children, fullWidth, sx, ...other }) => {
  const { classes } = useStyles();

  return (
    <AuthWrapper>
      <MainCard
        className={classes.card}
        contentClass={classes.content}
        sx={{ maxWidth: fullWidth ? '100%' : '475px', ...sx }}
        {...other}
      >
        <Box display="flex" alignItems="center" justifyContent="center" mb={5}>
          <Link href="/login">
            <Logo />
          </Link>
        </Box>
        {children}
      </MainCard>
    </AuthWrapper>
  );
};

export default LoggedOutLayout;
